import { rootApi } from "../../api/rootApi";

export const supplyBeamLocationsAdminApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // List locations for a tenant (admin panel)
    adminGetSupplyBeamLocations: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: "/admin/supply-beam-locations/",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),

    // Create location (admin panel)
    adminCreateSupplyBeamLocation: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: "/admin/supply-beam-locations/add",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),

    // Get location by id (admin panel)
    adminGetSupplyBeamLocationById: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/supply-beam-locations/${params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),

    // Update location (admin panel)
    adminUpdateSupplyBeamLocation: builder.mutation({
      query: (params) => ({
        method: "PUT",
        url: `/admin/supply-beam-locations/${params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),

    // Toggle location status (admin panel)
    adminToggleSupplyBeamLocationStatus: builder.mutation({
      query: (params) => ({
        method: "PUT",
        url: `/admin/supply-beam-locations/${params.id}/status`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: { status: params.status },
      }),
    }),
  }),
});

export const {
  useAdminGetSupplyBeamLocationsMutation,
  useAdminCreateSupplyBeamLocationMutation,
  useAdminGetSupplyBeamLocationByIdMutation,
  useAdminUpdateSupplyBeamLocationMutation,
  useAdminToggleSupplyBeamLocationStatusMutation,
} = supplyBeamLocationsAdminApi;
